<template>
  <div>
    <div class="drawingArea">
      <p>
        <canvas  ref="drawingCanvas" width='500' height='300' style="background-color: white; border-radius: 10px; margin-top: 10px;" id="drawingCanvas"></canvas>
      </p>
    </div>

    <div class="buttons" style="float: right; margin-bottom: 10px;">
      <b-button rounded :disabled="isCanvasEmpty"  class="is-warning" @click="resetCanvas">Reset</b-button>
      <b-button rounded :disabled="isCanvasEmpty" class="is-info" @click="addSignature">Add</b-button>
    </div>
  </div>
</template>

<script>

  import Signature from "@/classes/Signature";

  export default {

    name:'draw-signature',

    data(){
      return {

        canvas:null,
        isDrawing: false,
        startX: 0,
        startY: 0,
        points: [],
        DataUrl:'',

        isCanvasEmpty:true, // to enable add and clear buttons


      }
    },

    // watchers for the variables
    watch:{
      points(){
        // console.log("points length : "+this.points.length)
        if(this.points.length > 0){
          this.isCanvasEmpty=false
        }
      }
    },

    methods :{


      resetCanvas(){
        const comp = this
        comp.canvas.width = 500;
        comp.points.length = 0; // reset points array

        comp.isCanvasEmpty=true
      },

      addSignature(){

        var href = document.getElementById('drawingCanvas').toDataURL()

        // var link = document.createElement('a');
        // link.download = 'customer_drawn_signature.png';
        // link.href = href
        // link.click();
        //
        // setTimeout(() => {
        //   link.remove()
        //   window.URL.revokeObjectURL(href);
        // }, 100);



        this.$refs.drawingCanvas.toBlob((blob) => {
          let file = new File([blob], 'customer_drawn_signature.png', { type: "image/png" })

          let returnSignature = new Signature('canvas', href, file, false, null)
          this.$emit('on-add-signature', returnSignature) // test code
        }, 'image/png');
      },

      //drawing
      mousedown(e){
        var comp = this
        var rect = comp.canvas.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        comp.isDrawing = true;
        comp.startX = x;
        comp.startY = y;
        comp.points.push({
          x: x,
          y: y
        });
      },

      mousemove(e){
        var comp = this
        var rect = comp.canvas.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        if (comp.isDrawing) {
          comp.context.beginPath();
          comp.context.moveTo(comp.startX, comp.startY);
          comp.context.lineTo(x, y);
          comp.context.lineWidth = 2;
          comp.context.lineCap = 'round';
          comp.context.strokeStyle = "rgba(0,0,0,1)";
          comp.context.fillStyle = "#800";
          comp.context.stroke();

          comp.startX = x;
          comp.startY = y;

          comp.points.push({
            x: x,
            y: y
          });
        }
      },

      mouseup(){
        var comp = this
        comp.isDrawing = false;
        if (comp.points.length > 0) {
          localStorage['points'] = JSON.stringify(comp.points);
        }
      },


    },

    mounted () {

      var comp = this

      console.log("points length : "+comp.points.length)

      comp.canvas = comp.$refs.drawingCanvas
      comp.context = comp.canvas.getContext("2d");
      comp.canvas.addEventListener('mousedown', comp.mousedown);
      comp.canvas.addEventListener('mousemove', comp.mousemove)
      document.addEventListener('mouseup', comp.mouseup);

    },
  }

</script>

<style scoped>

</style>